module.exports = __webpack_public_path__ + "img/yidaima.5d321dd7.png";